import {
  Component,
  Input,
  Output, EventEmitter
} from '@angular/core';

const CLO_INPUT_VALID_TYPES = [
  'eye',
  'pencil',
  'heart',
  'heart-fill',
  'stack',
  'trash',
  'edit',
  'preview',
  'favorite',
  'remove-favorite',
  'copy',
  'delete'
];

/**
 * Buttons are used to make common actions immediately visible and easy to perform with one click, tap, or keypress.
 * Merchants can use them to navigate or to take action.
 *
 * It supports several button types.
 */
@Component({
  selector: 'clo-icon-button',
  templateUrl: './button-icon.html',
  styleUrls: ['./button.scss']
})
export class CloIconButton {

  /**
   * The label that is displayed on the button
   */
  @Input() label: string;

  /**s
   * Disable the button
   */
  @Input() disabled: boolean;

  /**
   * Type of the icon button.
   *
   *  The following types are supported: `'eye'`, `'pencil'`, `'heart'`, `'heart-fill'`,
   *  `'stack'`, `'trash'`, `'preview'`, `'edit'`, `'favorite'`, `'remove-favorite'`,
   *  `'copy'`, `'delete'`
   */
  @Input() type: string;

  /**
   * The default is secondary but you can also select `'tertiary'`
   */
  @Input() buttonStyle = 'secondary';

  @Output() buttonSubmitted = new EventEmitter();



}
